import { render } from "./footer.vue?vue&type=template&id=5f67a2f8&scoped=true"
import script from "./footer.vue?vue&type=script&lang=js"
export * from "./footer.vue?vue&type=script&lang=js"

import "./footer.vue?vue&type=style&index=0&id=5f67a2f8&lang=scss&scoped=true"

import exportComponent from "/Users/simongustafson/projekt/triathlon/triathlon/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f67a2f8"]])

export default __exports__